module.exports = __webpack_public_path__ + "static/media/msnp32_server_icon.940ee833.ico";